import { metrics } from './twin-metrics.js';
export function alarmParameters(signals, payload, language = 'it') {
  const result = new Map();
  for (const metric of metrics(payload, [], language)) {
    if (typeof metric.value !== 'number') continue;
    result.set(metric.key, { key: metric.key, label: metric.label, unit: payload?.measurements?.[metric.key]?.unit || '', origin: 'telemetry' });
  }
  let config;
  try { config = typeof signals === 'string' ? JSON.parse(signals) : signals; } catch { config = []; }
  for (const signal of Array.isArray(config) ? config : []) {
    if (!signal || typeof signal !== 'object') continue;
    const pathKey = typeof signal.source === 'string' ? signal.source.match(/^(?:payload\.)?measurements\.([^.]+)(?:\.value)?$/)?.[1] : '';
    const key = signal.key || signal.measurementKey || pathKey || (result.has(signal.name) ? signal.name : '');
    // A display name or OPC UA address is not necessarily a payload key.
    if (typeof key !== 'string' || !key) continue;
    const observed = result.get(key);
    result.set(key, { key, label: signal.name || observed?.label || key, unit: observed ? observed.unit : signal.unit || '', origin: observed ? 'telemetry' : 'configuration' });
  }
  return [...result.values()];
}
